import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import FaqListingPresenter from "./FaqListing.presenter";

import _ from "lodash";
import { AppNotifications, FaqOutputModel, RootState, TCb } from "../../../models";
import { AllLanguageListActions, NotificationActions } from "../../../store/actions";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./FaqListing.type";

import { INITIAL_FETCHING_PAGINATION_DATA } from "../../../constants";

import { withRouter } from "react-router-dom";
import { FaqService } from "../../../services";
import { loadCallback } from "../../../utils";

const EMPTY_FILTER: C_States["filter"] = {
  searchValue: "",
};

class FaqListingContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    const faqId = this.props.match.params.faqId;

    this.state = {
      filter: EMPTY_FILTER,
      fetchedFaq: INITIAL_FETCHING_PAGINATION_DATA,
      visibleFaqId: faqId,
      visibleFaqForm: Boolean(faqId),
    };
  }

  openFaqFormModal = (id?: string) => {
    this.setState({ visibleFaqId: id, visibleFaqForm: true }, () => {
      if (id) {
        this.props.history.push(`/faq/${id}`);
      }
    });
  };

  closeFaqFormModal = (cb?: TCb) => {
    this.props.history.push("/faq");
    this.setState({ visibleFaqId: undefined, visibleFaqForm: false }, () => {
      loadCallback(cb?.success);
    });
  };

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      },
    );
  }, 300);

  onApplyFilter = async (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedFaq.loading && loadMore) return;

    this.setState(
      (prevState) => {
        return {
          fetchedFaq: {
            ...prevState.fetchedFaq,
            data: loadMore ? prevState.fetchedFaq.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof FaqService.filterFaqs>[0] = {
          page: loadMore ? this.state.fetchedFaq.page + 1 : 1,
          limit: this.state.fetchedFaq.limit,
          searchValue: this.state.filter.searchValue || undefined,
        };

        FaqService.filterFaqs(query)
          .then((res) => {
            if (res && res.data) {
              this.setState(
                (prevState) => {
                  let faqs: FaqOutputModel[] = [...res.data];

                  if (loadMore) {
                    faqs.unshift(...prevState.fetchedFaq.data);
                  }

                  return {
                    fetchedFaq: {
                      ...res.data,
                      data: faqs,
                      loading: false,
                    },
                  };
                },
                () => {
                  loadCallback(cb?.success);
                },
              );
            } else {
              this.setState({
                fetchedFaq: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.setState({
              fetchedFaq: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      },
    );
  };

  onLoadMore = () => {
    this.onApplyFilter(true);
  };

  onDeleteFaq = (faqId: string) => {
    if (faqId) {
      FaqService.deleteFaq(faqId)
        .then((res) => {
          if (res && (res.status === 200 || res.status === 201)) {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.SUCCESS,
              message: "Delete FAQ success",
            });
            this.onApplyFilter(false);
          } else {
            this.props.actions.enqueueSnackbar({
              type: AppNotifications.ERROR,
              message: "Delete FAQ failed",
            });
          }
        })
        .catch((err) => {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Delete FAQ failed",
          });
        });
    }
  };

  render() {
    return (
      <FaqListingPresenter
        {...this.props}
        {...this.state}
        onLoadMore={this.onLoadMore}
        onSearch={this.onSearch}
        openFaqFormModal={this.openFaqFormModal}
        closeFaqFormModal={this.closeFaqFormModal}
        reloadListingPage={() => {
          this.onApplyFilter(false);
        }}
        onDeleteFaq={this.onDeleteFaq}
      />
    );
  }

  componentDidMount() {
    if (!this.props.all_language_list.data.length) {
      this.props.actions.getAllLanguages({
        success: () => {
          this.onApplyFilter(false, {
            success: () => {},
          });
        },
      });
    } else {
      this.onApplyFilter(false, {
        success: () => {},
      });
    }
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    }),
  )(FaqListingContainer),
);
